import { render, staticRenderFns } from "./statement-groups-layout.vue?vue&type=template&id=6e247b3d"
import script from "./statement-groups-layout.vue?vue&type=script&lang=js"
export * from "./statement-groups-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports